import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TaskTypeResponse } from '../models/task.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface TaskTypeDrawerOptions { typeId?: number; }

@Injectable({ providedIn: 'root' })
export class TaskTypeDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: TaskTypeDrawerOptions }>({
    isOpen: false, options: {}
  });
  private readonly saved$$ = new Subject<TaskTypeResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: TaskTypeDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }
  notifySaved(item: TaskTypeResponse): void { this.saved$$.next(item); }
}
